
const state = {
  data: {},
  digital_template_id: undefined,
  editor_id: undefined,
  editor_type: '',
  group_key: '',
  id: null,
  key: '',
  label: '',
  owner_id: undefined,
  owner_type: '',
  value: '',
}

export const requiredFields = [
  { key: 'key' },
]

export default state
